function envToBool(envVal: string | boolean = false): boolean {
  if (typeof envVal === 'string') {
    return envVal === 'true';
  }
  return !!envVal;
}
if (!envToBool(process.env.REACT_APP_SANITY_CHECK)) {
  throw new Error('env vars not loading');
}
const flags = {
  // Don't get clever with trying to do an accessor off process.env
  // webpack is doing string matching to replace these so if you use an accessor
  // it will break
  console: envToBool(process.env.REACT_APP_FF_console),
  isRenewWithExistingCreditCardEnabled: envToBool(
    process.env.REACT_APP_FF_isRenewWithExistingCreditCardEnabled,
  ),
  isPracticeModeEnabled: envToBool(process.env.REACT_APP_FF_isPracticeModeEnabled),
  isFavoritesEnabled: envToBool(process.env.REACT_APP_FF_isFavoritesEnabled),
  env: process.env.REACT_APP_WINNING_ENV_FILE,
  // TODO remove all flag dependent code for these
  isWelcomeModalEnabled: false,
};

export default flags;
